export default __webpack_public_path__ + "static/media/html.c48ef9b5.svg";